import { render, staticRenderFns } from "./AppCategories.vue?vue&type=template&id=2778da0a&scoped=true&"
import script from "./AppCategories.vue?vue&type=script&lang=js&"
export * from "./AppCategories.vue?vue&type=script&lang=js&"
import style0 from "./AppCategories.vue?vue&type=style&index=0&id=2778da0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2778da0a",
  null
  
)

export default component.exports